// library
import React from "react";

export default function Footer() {
  return (
    <footer className="p-2 mb-0" style={{ backgroundColor: "#5B5B5B" }}>
      <p
        className="m-3 text-center"
        style={{ color: "#FFFFFF", marginBottom: "0px" }}
      >
        Copyright &copy;2021 Made by Faiz Rofi Hencya
      </p>
    </footer>
  );
}
